import React, { type JSX } from 'react';

/**
 * Render a facebook-like placeholder. For instance
 * while waiting on a api call to complete.
 *
 * @example
 * <Placeholder/>
 */
export const Placeholder = (): JSX.Element => {
  return (
    <div className="c-placeholder">
      <div className="c-placeholder__line"/>
      <div className="c-placeholder__line"/>
      <div className="c-placeholder__line"/>
    </div>
  );
};
